export * from './bem-vindo.component';
